import React, { useState, useEffect } from 'react';

export default function AnimatedCounter({ end, duration = 2000, suffix = "", className = "" }) {
  const [count, setCount] = useState(0);
  const [ref, setRef] = useState(null);

  useEffect(() => {
    if (!ref) return;

    let startTimestamp = null;
    let animationFrameId;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startTimestamp = null;
          if (animationFrameId) window.cancelAnimationFrame(animationFrameId);

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            const easedProgress = 1 - Math.pow(1 - progress, 3);
            setCount(Math.floor(easedProgress * end));

            if (progress < 1) {
              animationFrameId = window.requestAnimationFrame(step);
            }
          };
          animationFrameId = window.requestAnimationFrame(step);
        } else {
          if (animationFrameId) window.cancelAnimationFrame(animationFrameId);
          setCount(0);
        }
      },
      { threshold: 0.2 }
    );

    observer.observe(ref);

    return () => {
      if (ref) observer.unobserve(ref);
      if (animationFrameId) window.cancelAnimationFrame(animationFrameId);
    };
  }, [ref, end, duration]);

  return (
    <span ref={setRef} className={className}>
      {count}{suffix}
    </span>
  );
}
